/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/sidebarItems.config.json';

import { StorageModule } from '@vlinder-web/storage-module-react';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_APPLICATION_COUNT } from '../graphql';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator';
import { apiConfig } from '@/config/apiConfig';
const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

interface ISidebarProps {
  whoami: string;
}

export interface ISidebarMethods extends IPluginMethodMap {
  getSidebarItems(args: ISidebarProps): Promise<any>;
}

export class SidebarItemService implements IAgentPlugin {
  readonly methods: ISidebarMethods;

  constructor() {
    this.methods = {
      getSidebarItems: this.getSidebarItems.bind(this),
    };
  }

  async getSidebarItems(args: ISidebarProps) {
    console.log(`getDraftApplicationsProps args`, args);
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    console.log('data in query', args);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const userProfile = storageService.get('myProfile', 'session');
    const role = userProfile?.org?.orgRole;
    const roetable = [
      {
        column: 'type',
        op: 'In',
        value: ['CARICOM_NEW_WORK_PERMIT','CARICOM_RENEW_WORK_PERMIT'],
      },
    ];
    console.log('sidebaritems-->', role);
    let countData;
    if (token) {
      try {
        if (client) {
          const res = await client.query(GET_APPLICATION_COUNT, {
            draftApp: {
              where: [
                ...(role === 'CARICOM_BUSSINESS_ORG' ? roetable : []),
                {
                  column: 'status',
                  value: ['APPLICANT_DRAFT', 'APPLICATION_INCOMPLETE'],
                  op: 'In',
                },
              ],
            },
            pendingPaymentApp: {
              where: [
                ...(role === 'CARICOM_BUSSINESS_ORG' ? roetable : []),

                {
                  column: 'status',
                  value: ['READY_TO_PAY', 'WAITING_FOR_WP_FEE'],
                  op: 'In',
                },
              ],
            },
            missingInfo: {
              where: [
                {
                  column: 'status',
                  op: 'In',
                  value: [
                    "MISSING_INFORMATION", "DOCUMENTATION_REJECTED"
                  ],
                },
              ],
            },
          });
          if (res?.data) {
            console.log(`getApplicationCount`, res?.data);
            countData = res?.data;
          } else {
            console.log('', res);
            if (res?.error) {
              return {
                error: true,
                isEmpty: true,
              };
            }
          }
        }
      } catch (err: any) {
        console.log(`error in table data`, err);
      }
    }

    const { whoami } = args;
    const items = config?.sidebarItems;
    const _items: any = [];
    //return { sidebarItems: items };

    for (let i = 0; i < items?.length; ++i) {
      const _item: any = items[i];
      if (_item?.children && !this.isBlackListFound(whoami, _item?.id)) {
        const _children: any = [];
        _item?.children.forEach((_childItem: any) => {
          // @ts-ignore

          if (_childItem?.id) {
            console.log('par->child->', _childItem?.id);
            if (!this.isBlackListFound(whoami, _childItem?.id)) {
              console.log('par->child->', _childItem?.id);
              _children.push(_childItem);
            }
          }
        });
        const _temp = { ..._item };
        _temp.children = _children;
        _items.push(_temp);
      } else if (_item?.id) {
        console.log('par->', _item?.id);
        if (!this.isBlackListFound(whoami, _item?.id)) {
          console.log('par->', _item?.id);
          _items.push(_item);
        }
      } else {
        _items.push(_item);
      }
    }
    console.log('SIdebarTItem', _items);
    const updates = [
      { id: 'DraftAppList', badgeText: countData?.draftApp, badgeBg: 'danger' },
      {
        id: 'PendingPayment',
        badgeText: countData?.pendingPaymentApp,
        badgeBg: 'danger',
      },
      {
        id: 'MissingInfo',
        badgeText: countData?.missingInfo,
        badgeBg: 'danger',
      },
    ];
    let updatedSideBarITems = this.updateBadgesByIds(_items, updates);

    console.log('UpdatedITems', updatedSideBarITems);

    return { sidebarItems: updatedSideBarITems };
  }

  private updateBadgesByIds = (data: any, updates: any) => {
    return data.map((item: any) => {
      const update = updates.find((update: any) => update.id === item.id);

      if (update) {
        return {
          ...item,
          badgeText: update.badgeText,
          badgeBg: update.badgeBg,
        };
      } else if (item.children) {
        return {
          ...item,
          children: this.updateBadgesByIds(item.children, updates),
        };
      }

      return item;
    });
  };

  private isBlackListFound(whoami: string, id: string) {
    console.log('whoami', whoami);
    let _found = false;
    // @ts-ignore
    const blacklist = config['blacklistItems'][whoami];

    if (blacklist) {
      if (blacklist.find((bl: any) => bl == id)) {
        _found = true;
      }
    }
    console.log('black->', blacklist, id, _found);
    return _found;
  }
}
